import { render, staticRenderFns } from "./commodityEdit.vue?vue&type=template&id=652cfa3e&scoped=true&"
import script from "./commodityEdit.vue?vue&type=script&lang=js&"
export * from "./commodityEdit.vue?vue&type=script&lang=js&"
import style0 from "./commodityEdit.vue?vue&type=style&index=0&id=652cfa3e&scoped=true&lang=less&"
import style1 from "./commodityEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652cfa3e",
  null
  
)

export default component.exports